import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { API_FightResults } from 'shared';
import Dialog from '../../../../general/dialog';
import Button from '../../../../controls/button';
import CreamCan from '../../../../../assets/images/common/creamCan';
import LoadableImage from '../../../../general/loadableImage';
import { useAssets } from '../../../../../contexts/assets';

interface Props {
  results: API_FightResults;
  active: boolean;
}

const FightResultsCongrats = ({ results, active }: Props) => {
  const { sound } = useAssets();
  const triggered = useRef(false);
  const [creamOpened, setCreamOpened] = useState(false);
  const [rankOpened, setRankOpened] = useState(false);

  useEffect(() => {
    if (!triggered.current) {
      triggered.current = true;
      const needBet = results.selfWinner && results.bet > 0;
      const needRank =
        results.levelChange > 0 &&
        results.nftData.rank.name !== results.nftData.oldRank.name;
      if (active) {
        openDialogs(needBet, needRank);
        playInitialSound(needBet, needRank, results);
      } else {
        playInitialSound(false, false, results);
      }
    }
  }, [results, active]);

  const playInitialSound = (
    bet: boolean,
    rank: boolean,
    data: API_FightResults
  ) => {
    if (bet) {
      return sound.cashReceive();
    }
    if (rank) {
      return sound.rankUpgrade();
    }
    if (data.selfWinner) {
      return sound.fight.win();
    }
    if (data.isDraw) {
      return sound.fight.draw();
    }
    return sound.fight.lose();
  };

  const openDialogs = (needBet: boolean, needRank: boolean) => {
    setCreamOpened(needBet);
    setRankOpened(needRank);
  };

  const closeCream = () => {
    setCreamOpened(false);
    if (rankOpened) {
      sound.rankUpgrade();
    } else {
      sound.gotCash();
    }
  };

  const closeRank = () => {
    setRankOpened(false);
  };

  return (
    <>
      <Dialog
        className='results-cream-dialog'
        opened={creamOpened}
        onClose={closeCream}
        maxWidth='sm'
        noCloseOnMobile
      >
        <h4 className='rcd-header'>Your Reward</h4>
        <div className='rcd-cream-line'>
          <h1 className='rcd-cream-line-text'>+{results.bet * 2}</h1>
          <CreamCan className='rcd-cream-line-can' />
        </div>
        <LoadableImage
          src='/assets/images/fightResults/safe.png'
          className='rcd-safe'
        />
        <Button onClick={closeCream} noSound>
          Awesome!
        </Button>
      </Dialog>
      <Dialog
        className='results-rank-dialog'
        opened={rankOpened && !creamOpened}
        onClose={closeRank}
        maxWidth='sm'
        noCloseOnMobile
      >
        <h4 className='rrd-header'>You unlocked a new rank</h4>
        <h1 className='rrd-rankname'>{results.nftData.rank.name}</h1>
        <LoadableImage
          src='/assets/images/fightResults/medal.png'
          className='rrd-medal'
        />
        <Button color='secondary' onClick={closeRank}>
          Yes, Sir!
        </Button>
      </Dialog>
    </>
  );
};

export default FightResultsCongrats;
